/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

namespace Application.Services {
    'use strict';

    import MobileDevice = Models.MobileDevice;
    import NetworkNode = Models.NetworkNode;
    import NetworkNodeModem = Models.NetworkNodeModem;
    import ISim = Models.ISIM;
    import HalConverter = Models.HalConverter;
    import IPaginatedList = Models.IPaginatedList;

    /**
     * NetworkNodeService
     */
    export class MobileDevicesService {
        public static $name: string = "mobileDevicesService";
        public static $inject: string[] = ['networkNodeTypeService',
                                           '$q',
                                           'backendService',
                                           'simService',
                                           'networkNodeModemService',
                                           'networkNodeService',
                                           ];

        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'networknodes/';
        private servicePath: string = '';
        private modemsBackendUrl: string = this.backendBaseUrl + this.servicePath + 'modems';
        private dashboardUrl: string = this.backendBaseUrl + this.servicePath + 'mobileDevices/dashboard/';

        private mobileDevice: Models.MobileDevice;
        
        constructor(private networkNodeTypeService: Application.Services.NetworkNodeTypeService,
                    private $q: ng.IQService,
                    private backendService: BackendService,
                    private simService: SIMService,
                    private networkNodeModemService: NetworkNodeModemService,
                    private networkNodeService: NetworkNodeService) {
        }

        public getMobileDeviceDashboard(id: string): ng.IPromise<Models.IMobileDeviceDashboard> {
            return this.backendService.get(this.dashboardUrl + id)
                    .then((deviceDashboard: ng.IHttpPromiseCallbackArg<Models.IMobileDeviceDashboard>) => {
                        HalConverter.selfConvertLinks(deviceDashboard.data.networkNode);
                        deviceDashboard.data.networkNode = HalConverter.convertElement(deviceDashboard.data.networkNode as 
                            Models.IHalElement<NetworkNode>, Models.NetworkNode.Empty);
                        return deviceDashboard.data;
                    });
        }

        public getAllPaginatedMobileDevices(page?: number, size?: number, sort?: String): ng.IPromise<IPaginatedList<MobileDevice>> {
            return this.$q.all([
                this.networkNodeService.getAllPaginatedNetworkNodesPromise(page, size, sort),
                this.simService.getAllSIMs(),
                this.networkNodeModemService.getAllPaginatedNetworkNodeModems(undefined, 999999999, undefined),
            ])
            .then((res: Object[]) => {
                let resNetworkNodes: IPaginatedList<NetworkNode> = res[0] as IPaginatedList<NetworkNode>;
                let resSims: IPaginatedList<ISim> = res[1] as IPaginatedList<ISim>;
                let resModems: IPaginatedList<NetworkNodeModem> = res[2] as IPaginatedList<NetworkNodeModem>;
                let nodeWithModemIds: boolean[] = new Array();
                if (resModems !== undefined) {
                    resModems.elements.forEach((modem: NetworkNodeModem) => {
                        nodeWithModemIds[modem.networkNode] = true;
                    });
                }
                let mobileDevices: IPaginatedList<MobileDevice> = new Models.PaginatedList<MobileDevice>();
                mobileDevices.page = resNetworkNodes.page;
                resNetworkNodes.elements.forEach((networkNode: NetworkNode) => {
                    if (nodeWithModemIds[Common.Utils.idFromHref(networkNode.href)] === true) {
                        // mobile device element
                        let mobileDevice: MobileDevice = new MobileDevice();
                        // network node information
                        mobileDevice.networkNode = networkNode;
                        // sims
                        mobileDevice.sims = new Array();
                        for (let i: number = 0; i < resSims.elements.length; i++) {
                            if (resSims.elements[i].networkNodeModem &&
                                (resSims.elements[i].networkNodeModem.networkNode as NetworkNode).href === networkNode.href) {
                                mobileDevice.sims.push(resSims.elements[i]);
                            }
                        }
                        // total remaining data
                        mobileDevice.totalRemainingData = 0;
                        for (let i: number = 0; i < mobileDevice.sims.length; i++)
                            mobileDevice.totalRemainingData += mobileDevice.sims[i].remainingData;
                        // place all into the mobileDevices paginated element and return it
                        mobileDevices.elements.push(mobileDevice);
                    }
                });
                return mobileDevices;
            });
        }

        public deleteNetworkNodeModemsByNetworkNodeId(networkNodeId: number): ng.IPromise<Boolean> {
            return this.backendService.delete(this.modemsBackendUrl + "/findByNetworkNode/" + networkNodeId);
        }

        public getMobileDevice(id: number): Models.MobileDevice {
            return this.mobileDevice;
        }

        public setMobileDevice(mobileDevice: Models.MobileDevice): void {
            this.mobileDevice = mobileDevice;
        }
    }
}